import { Component } from '@angular/core';
import { RouterAppBusyStateComponentDef } from '@df/ui/display/busy-state/router-app-busy-state.component.def';
@Component({
    selector: 'router-app-busy-state',
    template: `
        <ng-template #defaultTpl>
            <i class="fs-10 icon-loading"></i>
        </ng-template>
    `,
    standalone: true
})
export class RouterAppBusyStateComponent extends RouterAppBusyStateComponentDef {}
